import { useState } from 'react';

// https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
export default function usePageVisibility() {
  let hidden = '';
  let visibilityChange = '';

  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
  const [isHidden, setIsHidden] = useState(hidden ? document[hidden] : false);

  if (hidden) {
    document.addEventListener(visibilityChange, () => {
      setIsHidden(document[hidden]);
    });
  }

  return isHidden;
}
